import { fetchSanity } from "./client";
import {
  ALL_BLOG_POSTS_QUERY,
  ALL_CATEGORIES_QUERY,
  BLOG_POSTS_BY_CATEGORY_QUERY,
  BLOG_POST_BY_SLUG_QUERY,
  SEARCH_POSTS_QUERY,
} from "./queries";
import type { Post, Category } from "./types";

export async function getAllBlogPosts(): Promise<Post[]> {
  const data = await fetchSanity<Post[]>(ALL_BLOG_POSTS_QUERY);
  return data ?? [];
}

export async function getAllCategories(): Promise<Category[]> {
  const data = await fetchSanity<Category[]>(ALL_CATEGORIES_QUERY);
  return data ?? [];
}

export async function getBlogPostsByCategory(slug: string): Promise<Post[]> {
  const data = await fetchSanity<Post[]>(BLOG_POSTS_BY_CATEGORY_QUERY, {
    slug,
  });
  return data ?? [];
}

export async function getBlogPostBySlug(slug: string): Promise<Post | null> {
  const data = await fetchSanity<Post | null>(BLOG_POST_BY_SLUG_QUERY, {
    slug,
  });
  return data ?? null;
}

export async function searchBlogPosts(query: string): Promise<Post[]> {
  if (!query) return [];
  const data = await fetchSanity<Post[]>(SEARCH_POSTS_QUERY, {
    q: `${query}*`,
  });
  return data ?? [];
}
